import type {PropsWithChildren} from 'react'
import {Link} from '@primer/react'
import styles from './TopicLabel.module.css'

// This component doesn't exist right now in any of the Primer implementations
// However it's been used in a lot of places right now.

export default function TopicLabel({children, href}: PropsWithChildren<{href?: string}>) {
  return (
    <Link href={href} className={styles.topicLabel}>
      {children}
    </Link>
  )
}
